import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';

const UserGroupFieldInput = ({
  autoFocus,
  className,
  icon,
  iconPosition,
  maxLength,
  onChange,
  size,
  text,
  type,
}) => {
  const intl = useIntl();
  return (
    <Input
      fluid
      autoFocus={autoFocus}
      icon={icon}
      iconPosition={iconPosition}
      size={size}
      className={clsx('aridhia-usergroup-field-input aridhia-is-edit-mode primary', className)}
      value={text || ''}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `usergroup.${type}.placeholder` })}
      onChange={(e, { value }) => { onChange(value); }}
    />
  );
};

export default UserGroupFieldInput;
